import { useTranslation } from '@frontend/i18n';
import { usePaymentMethods } from '../../../hooks/settings/use-payment-methods';
import { PaymentMethodRow } from '../atoms/payment-method-row';
import { AffirmToggleSwitch } from '../molecules/affirm-toggle-switch';
import * as styles from '../styles/payment-settings-page.styles';

const affirmLearnMoreLink = 'https://www.affirm.com/';

export const PaymentMethods = () => {
  const { t } = useTranslation('payments', { keyPrefix: 'settings' });
  const { stripeAffirmPaymentLocations } = usePaymentMethods();
  return (
    <section css={[styles.form]}>
      {!!stripeAffirmPaymentLocations.length && (
        <PaymentMethodRow
          title={t('Affirm')}
          learnMoreLink={affirmLearnMoreLink}
          subtitle={t(
            'Affirm gives your customers a way to split purchases over a series of payments. This option will appear on Online Bill Pay pages (including Text to Pay).'
          )}
          switchField={<AffirmToggleSwitch />}
          enabledLocations={stripeAffirmPaymentLocations}
        />
      )}
    </section>
  );
};
